import trackingService from "@/js/common/Domain/Service/tracking/tracking";

export default function setTbankAnalyticsConditionally() {
  const clientUuid = window.appConfig?.clientUuid;
  const includedPath = window.location.pathname !== '/tinkoff/frame-mobile-new';

  const match = document.cookie.match(/(?:^|; )tbankSubscriptionType=([^;]*)/);

  if (!(includedPath && match && match[1])) return;

  trackingService.trackSetAnalytics({
    clientUuid,
    tbankSubscriptionType: decodeURIComponent(match[1])
  });
}